module.exports = __webpack_public_path__ + "static/media/13n.3dc7d7dc.svg";